/**
 * Error event name for a client connection timeout.
 * @constant {string}
 */
const clientTimeout = 'connectionTimeout';

/**
 * Error event name for a reconnection failure.
 * @constant {string}
 */
const reconnectionFailure = 'reconnectionFailure';

/**
 * Error event name for an unauthenticated user.
 * @constant {string}
 */
const unauthenticated = 'userUnauthenticated';

/**
 * Error event name for rate limiting.
 * @constant {string}
 */
const rateLimited = 'rateLimited';

/**
 * Error event name for a disabled service.
 * @constant {string}
 */
const serviceDisabled = 'serviceDisabled';

/**
 * Error event name for an unauthorized user.
 * @constant {string}
 */
const unauthorized = 'userUnauthorized';

export {
  clientTimeout,
  rateLimited,
  reconnectionFailure,
  unauthenticated,
  unauthorized,
  serviceDisabled,
};
